
export class UserLogin {
 "UserName": string;
 "Password": string;
 "ConfirmPassword"?: string;
 "EmailAddress"?: string;
 "token"?: string;
}
